/**------------- Icon Button constants -------------**/

/*  General  */
export const ICON_BUTTON_CLASS_NAME = "icon-button";

/*  Icon  */
export const ICON_BUTTON_IMAGE_ALT = "button-with-icon";
